import { render, staticRenderFns } from "./Despeses.vue?vue&type=template&id=d6e5fde8&"
import script from "./Despeses.vue?vue&type=script&lang=js&"
export * from "./Despeses.vue?vue&type=script&lang=js&"
import style0 from "./Despeses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports